<template>
  <div v-if="showModal" class="modal">
    <div class="modal_box">
      <div class="modal_content">
        <slot />
      </div>
      <div class="modal_footer">
        <a-button v-if="showCancel" @click="cancel">{{ cancelText }}</a-button>
        <a-button v-if="showConfirm" type="primary" style="margin-left: 15px;" @click="confirm">{{ confirmText }}</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import zh from '@/lang/zh.json'
import en from '@/lang/en.json'
import { getLKey } from '@/utils/auth'

const i18n = { zh, en }
const lang = getLKey()

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: i18n[lang]['admin-profile-edit/cancel']
    },
    confirmText: {
      type: String,
      default: i18n[lang]['view-components-components/confirm']
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
<style>
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .modal_box {
        width: 54vw;
        min-width: 450px;
        background: #fff;
        background:rgba(255,255,255,1);
        box-shadow:-1px 8px 48px 9px rgba(24,24,24,0.17);
        border-radius:10px;
        margin: 12vh auto;
        padding: 0 22px;
        position: relative;
    }

    .modal_content {
        padding: 5.5vh 5vh;
        font-size: 18px;
    }

    .modal_footer {
        border-top: 2px solid #f8f8f8;
        width: 100%;
        height:70px;
        text-align: right;
        padding: 17px 0;
    }
</style>
